import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const PageHero = ({ 
  title, 
  subtitle, 
  image = '/images/about-hero.webp',
  buttons = [],
  minHeight = '350px'
}) => {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute w-full h-full inset-0 bg-gradient-to-r from-black/70 to-transparent z-[2]"></div>
      <img 
        className="absolute w-full h-full top-0 right-0 object-center object-cover"
        src={image}
        alt={`${title} Hero`}
      />
      <div className="container relative z-[3] flex flex-col gap-5" style={{ minHeight }}>
        <motion.h2 
          className="text-4xl md:text-5xl font-bold text-white text-center pt-10"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {title}
        </motion.h2>
        {subtitle && (
          <motion.p 
            className="text-md text-white text-center max-w-xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {subtitle}
          </motion.p>
        )}
        {buttons.length > 0 && (
          <motion.div 
            className="flex gap-5 justify-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            {buttons.map((button, index) => (
              <Link key={index} to={button.to}>
                <button className="px-6 py-2 bg-white text-gray-900 rounded-full hover:bg-gray-100 transition-colors">
                  {button.label}
                </button>
              </Link>
            ))}
          </motion.div>
        )}
      </div>
      <svg 
        width="1896" 
        height="75" 
        viewBox="0 0 1896 75" 
        className="absolute -bottom-2 left-1/2 -translate-x-1/2 z-[3]" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1896 71.0298L0 74.5301C500.5 -69.4708 1896 39.5297 1896 39.5297V71.0298Z" className="fill-gray-100" />
      </svg>
    </section>
  );
};

export default PageHero; 